// src/components/common/ErrorBoundary.jsx
import React from 'react'
import ErrorBlock from './ErrorBlock.jsx'

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false, error: null }
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error }
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error caught by boundary:', error, errorInfo)
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-gray-50">
                    <div className="max-w-md w-full">
                        <ErrorBlock
                            title="Application Error"
                            message="Something went wrong in this part of the application. Please refresh the page and try again."
                            onRetry={() => window.location.reload()}
                        />
                    </div>
                </div>
            )
        }

        return this.props.children
    }
}